import { Observer } from 'mobx-react-lite';
import React from 'react';
import ReactDOM from 'react-dom';
import packageJson from '../package.json';
import './App.scss';
import ContactForm from './components/ContactForm/ContactForm';
import { DialogStack } from './components/Dialog/DialogStack';
import DonateForm from './components/DonateForm/DonateForm';
import NavSearch from './components/NavSearch/NavSearch';
import OverlayStack from './components/Overlay/OverlayStack';
import SupportGroupFeed from './components/SupportGroupFeed/SupportGroupFeed';
import Symbols from './components/Symbols/Symbols';
import ThoughtFeed from './components/ThoughtFeed/ThoughtFeed';
import { useControllers, useRootController } from './hooks/controller.hooks';
import { useOnMount } from './hooks/lifecycle.hooks';
import { useObservableRef } from './hooks/useObservableRef.hook';
import { useStore } from './utils/mobx.utils';
var App = function (props) {
    var ROOT = useRootController();
    var UI = useControllers().UI;
    var s = useStore(function () { return ({
        thoughtFeedPortal: document.querySelector('[data-react-portal="thought-feed"]'),
        supportGroupFeedPortal: document.querySelector('[data-react-portal="support-group-feed"]'),
        donateFormFeedPortal: document.querySelector('[data-react-portal="donate-form"]'),
        contactFormFeedPortal: document.querySelector('[data-react-portal="contact-form"]'),
        searchFormPortal: document.querySelector('[data-react-portal="search-form"]'),
        // pageSearchResultsPortal: document.querySelector('[data-react-portal="page-search-results"]'),
    }); });
    var portalRef = useObservableRef();
    useOnMount(function () {
        UI.PORTAL.registerRef(portalRef);
        document.documentElement.setAttribute('data-app-version', packageJson.version);
    });
    return (React.createElement(Observer, { children: function () {
            return ROOT.$ready ? (React.createElement("div", { className: "App" },
                React.createElement(Symbols, null),
                s.thoughtFeedPortal &&
                    ReactDOM.createPortal(React.createElement(ThoughtFeed, null), s.thoughtFeedPortal),
                s.supportGroupFeedPortal &&
                    ReactDOM.createPortal(React.createElement(SupportGroupFeed, null), s.supportGroupFeedPortal),
                s.donateFormFeedPortal &&
                    ReactDOM.createPortal(React.createElement(DonateForm, null), s.donateFormFeedPortal),
                s.contactFormFeedPortal &&
                    ReactDOM.createPortal(React.createElement(ContactForm, null), s.contactFormFeedPortal),
                s.searchFormPortal &&
                    ReactDOM.createPortal(React.createElement(NavSearch, null), s.searchFormPortal),
                React.createElement(DialogStack, null),
                React.createElement(OverlayStack, null),
                React.createElement("div", { className: "AppPortal", ref: portalRef }))) : null;
        } }));
};
export default App;
